import { CreditsMeter } from "@/features/upgrade/CreditsMeter"
import useUser from "@/hooks/useUser"
import FreeTrial from "./FreeTrial"

/** The credits of a Starter organization in the sidebar, where a trial sees its
 *  quota. Every member sees the same pool, whoever bought the plan. */
export const CreditsCard: React.FC = () => {
  const { user } = useUser()
  if (!user?.groups.includes("Starter") || user.groups.includes("Pilot")) {
    return null
  }
  return (
    <FreeTrial.Card dataTestId="credits-card">
      <CreditsMeter />
    </FreeTrial.Card>
  )
}
